var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { createTransformer } from 'mobx-utils';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { AspectActive } from './4_active/AspectActive';
import { AspectKeyGlobal } from '../traitKey/AspectKeyGlobal';
import { AspectKeyProxies } from '../traitKey/proxies/AspectKeyProxies';
export class AspectGlobal {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get aspect() {
        return this.parent;
    }
    get activesOf() {
        return this.aspect.global.globalEval.activesOf;
    }
    get activeOf() {
        return this.aspect.global.globalEval.activeOf;
    }
    get atsOf() {
        return this.aspect.global.globalEval.atsOf;
    }
    get atOf() {
        return this.aspect.global.globalEval.atOf;
    }
    get valueOf() {
        return this.aspect.global.globalEval.valueOf;
    }
    get valuesOf() {
        return this.aspect.global.globalEval.valuesOf;
    }
    get valueOrValuesOf() {
        return this.aspect.global.globalEval.mixedValueOf;
    }
    get scaledValueOf() {
        return this.aspect.global.globalEval.scaledValueOf;
    }
    get aspectActive() {
        return new AspectActive(this);
    }
    get aspectKey() {
        return createTransformer((traitKey) => new AspectKeyGlobal(this, traitKey));
    }
    get globalEval() {
        return new AspectKeyProxies(this);
    }
}
__decorate([
    memoize
], AspectGlobal.prototype, "aspectActive", null);
__decorate([
    memoize
], AspectGlobal.prototype, "aspectKey", null);
__decorate([
    memoize
], AspectGlobal.prototype, "globalEval", null);
